import { withPublicHOC } from '../../hoc';

const RefundPolicy = () => {
  return <h1>RefundPolicy</h1>;
};

export default withPublicHOC(RefundPolicy);
